import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import type { BackLinkProps } from "../types/navigation.js";

export function BackLink({ to, controlId, children }: BackLinkProps) {
  return (
    <Link
      className="mb-6 inline-flex items-center gap-2 rounded text-sm font-medium text-muted-foreground hover:text-link focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30"
      data-control-id={controlId}
      to={to}
    >
      <ArrowLeft aria-hidden="true" className="size-4" />
      {children}
    </Link>
  );
}
